import { useLanguage } from "@/components/language-provider";
import { LegalLayout } from "@/components/legal-layout";

export default function Privacy() {
  const { language } = useLanguage();

  if (language === "en") {
    return (
      <LegalLayout title="Privacy Policy">
        <p className="text-muted-foreground text-sm mb-8">Last updated: January 2026</p>
        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly (name, email, company) and data generated from your use of the Service (documents, signatures, IP addresses, access logs).</p>
        <h2>2. How We Use Your Data</h2>
        <p>Your data is used to provide the Service, improve user experience, ensure security, comply with legal obligations, and communicate important updates.</p>
        <h2>3. Data Storage and Security</h2>
        <p>All data is encrypted at rest (AES-256) and in transit (TLS 1.3). Documents are stored in secure, geographically redundant data centers.</p>
        <h2>4. Data Sharing</h2>
        <p>We do not sell your data. We may share data with service providers who assist in delivering the Service, under strict confidentiality agreements.</p>
        <h2>5. Your Rights (LGPD)</h2>
        <p>Under the Brazilian General Data Protection Law (LGPD), you have the right to access, correct, delete, and port your personal data. Contact our DPO at privacy@fillsign.com.</p>
        <h2>6. Cookies</h2>
        <p>We use essential cookies for authentication and preferences. Analytics cookies are only used with your consent.</p>
        <h2>7. Contact</h2>
        <p>For privacy inquiries, contact our Data Protection Officer at privacy@fillsign.com.</p>
      </LegalLayout>
    );
  }

  return (
    <LegalLayout title="Política de Privacidade">
      <p className="text-muted-foreground text-sm mb-8">Última atualização: Janeiro de 2026</p>
      <h2>1. Informações que Coletamos</h2>
      <p>Coletamos informações que você fornece diretamente (nome, email, empresa) e dados gerados pelo uso do Serviço (documentos, assinaturas, endereços IP, logs de acesso).</p>
      <h2>2. Como Usamos seus Dados</h2>
      <p>Seus dados são utilizados para fornecer o Serviço, melhorar a experiência, garantir segurança, cumprir obrigações legais e comunicar atualizações importantes.</p>
      <h2>3. Armazenamento e Segurança</h2>
      <p>Todos os dados são criptografados em repouso (AES-256) e em trânsito (TLS 1.3). Documentos são armazenados em data centers seguros com redundância geográfica.</p>
      <h2>4. Compartilhamento de Dados</h2>
      <p>Não vendemos seus dados. Podemos compartilhar dados com prestadores de serviço que auxiliam na entrega do Serviço, sob acordos rigorosos de confidencialidade.</p>
      <h2>5. Seus Direitos (LGPD)</h2>
      <p>Conforme a Lei Geral de Proteção de Dados (LGPD), você tem direito de acessar, corrigir, excluir e portar seus dados pessoais. Contate nosso DPO em privacy@fillsign.com.</p>
      <h2>6. Cookies</h2>
      <p>Utilizamos cookies essenciais para autenticação e preferências. Cookies analíticos são usados apenas com seu consentimento.</p>
      <h2>7. Contato</h2>
      <p>Para questões de privacidade, contate nosso Encarregado de Proteção de Dados em privacy@fillsign.com.</p>
    </LegalLayout>
  );
}
